import './style.css';
import {Map, View} from 'ol';
import Tile from 'ol/layer/Tile';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS.js';
import OSM from 'ol/source/OSM';
import GeoJSON from 'ol/format/GeoJSON.js';
import Projection from 'ol/proj/Projection.js';
import proj4 from 'proj4';
import {register} from 'ol/proj/proj4.js';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector.js';
import Style from 'ol/style/Style.js';
import Icon from 'ol/style/Icon.js';
import ScaleLine from 'ol/control/ScaleLine.js';
import {defaults as defaultControls} from 'ol/control/defaults.js';

import GLBugES from './varios/KprGisWeb-es.pdf';
import GLBugEN from './varios/KprGisWeb-en.pdf';
import GLBtradURLes from './traducciones3/es.json?url';
import GLBtradURLen from './traducciones3/en.json?url';
import GLBanalisisHTMLes from './analisis_es.html?url';
import GLBanalisisHTMLen from './analisis_en.html?url';

import centralIcon from './img/central.png'; './img/bolaverde.gif'
import bolaverdeIcon from './img/bolaverde.gif';
import bolaazulIcon from './img/bolaazul.gif';
import fabricaIcon from './img/fabrica.png';
import almacenIcon from './img/almacen.png';
import minaIcon from './img/mina.png';
import centroinvestigacionIcon from './img/centro-investigacion.png';
import contaminadasIcon from './img/contaminadas.png';


// Global variables
var GLBfechaMinLang = {};
var GLBfechaMaxLang = {};
const GLBdateMinConsultable = new Date('2006-01-01');
const GLBdateMaxConsultable = new Date('2050-12-31');
var offset, fechaoffset, GLBfechaISO;
var day, month, year;
offset = GLBdateMinConsultable.getTimezoneOffset();
fechaoffset = new Date(GLBdateMinConsultable.getTime() - (offset*60*1000));
GLBfechaISO = fechaoffset.toISOString().split('T')[0];
[year, month, day] = GLBfechaISO.split('-');
GLBfechaMinLang['es'] = `${day}/${month}/${year}`;
GLBfechaMinLang['en'] = `${month}/${day}/${year}`;

offset = GLBdateMaxConsultable.getTimezoneOffset();
fechaoffset = new Date(GLBdateMaxConsultable.getTime() - (offset*60*1000));
GLBfechaISO = fechaoffset.toISOString().split('T')[0];
[year, month, day] = GLBfechaISO.split('-');
GLBfechaMaxLang['es'] = `${day}/${month}/${year}`;
GLBfechaMaxLang['en'] = `${month}/${day}/${year}`;



const monthNames = {
  'es': ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
  'en': [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ]
};
const dayNames = {
  'es': ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do'],
  'en': ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']
};
const dateFormats = {
  'es': 'dd/mm/yy',
  'en': 'mm/dd/yy'
}

var GLBfechaInicio;
var GLBfechaFin;
// var GLBfechaInicioPL;			//formato: DD/MM/AAAA
// var GLBfechaFinPL;
var GLBMuestra;		//AGU, AIR, 
var GLBmuestraId;		//AGU, AIR, 
var GLBmuestraIdIsot;
var GLBAnalisis;	//Ac228N
var GLBIdZonaVigilancia;	//DUE,
var GLBZonaVigilancia;
var GLBTipoVigilancia;
var GLBIDestacion;
var GLBNombreEstacion;
var GLBPrograma;	//todasVigilancias, ...
var GLBidiomaActual='es';
var GLBmuestrasEstacion; // Array para almacenar las muestras de una estación
var GLBdownloadTitle;
var GLBtraduccionES;
var GLBtraduccionEN;
var GLBbuscadorShown = true;

const GLBtradURL = {
  'es': GLBtradURLes,
  'en': GLBtradURLen
};
const GLBug = {
  'es': GLBugES,
  'en': GLBugEN,
};
const GLBanalisisHTML = {
  'es': GLBanalisisHTMLes,
  'en': GLBanalisisHTMLen,
};

var GLBvlayerSources = {
    'estResto': {},  // Conjunto de estaciones que no pertenecen a la red nacional ni a la vigilancia de las instalaciones
    'estREM': {},    // Estaciones de la red nacional
    'estPVRA': {}    // Estaciones pertenecientes a la vigilancia de las instalaciones
}; // Hashmap con las 3 capas vectoriales

// Dar valores iniciales al hashmap de capas vectoriales
for (var layer in GLBvlayerSources) {
    GLBvlayerSources[layer] = {
        'type': 'FeatureCollection',
        'crs': {
            'type': 'name',
            'properties': {
                // 'name': 'EPSG:3857',   // WGS84 / Pseudo-Mercator
                // 'name': 'EPSG:4326',   // WGS84
                'name': 'EPSG:4258',   // ETRS89
                // 'units': 'm',      
                'units': 'degrees',
            },
        },
        features: []  // Conjunto de objetos (estaciones) de la capa vectorial
    };
};

var GLBhost = 'https://www.csn.es';   // Nombre del host para añadir a las URLs de las instalaciones.

// URLs a las que se apunta cuando se hace click sobre una instalación en vez de sobre una estación de muestreo.
// La clave de cada entrada es la zona de vigilancia.
const GLBinstURLs = {
    'ALM': '/central-nuclear/almaraz/informacion-general',
    'ASC': '/centrales-nucleares-de-espana/asco',
    'BFH': '',
    'CDF': '/mineria-de-uranio',
    'CIE': '/ciemat-pimic/datos-generales',
    'COF': '/centrales-nucleares-de-espana/cofrentes',
    'CRI': '/sistema-de-vigilancia-ambiental-en-espana',
    'ELQ': '/planta-quercus/datos-generales',
    'FUA': '/fabrica-uranio-andujar/datos-generales',
    'HAB': '/sistema-de-vigilancia-ambiental-en-espana',
    'JCA': '/central-nuclear/jose-cabrera/datos-generales',
    'JUZ': '/informacion-general10',
    'PAL': '/documents/10182/1008558/Palomares.%20En%20el%20camino%20de%20la%20normalización%20radiológica',
    'SAB': '/almacen-centralizado-el-cabril1',
    'SMG': '/centrales-nucleares-de-espana/santa-maria-de-garona',
    'TRI': '/centrales-nucleares-de-espana/trillo',
    'VAL': '/mineria-de-uranio',
    'VN1': '/instalaciones-en-desmantelamiento/vandellos-1',
    'VN2': '/centrales-nucleares-de-espana/vandellos-ii',
};

//Origen de datos
var conJSON=0;	//0prod, 1 jsonlocal, 2:pc EFI

// Hacer debugging  de la URL de origen de las estaciones
var debugURL=0;

// Ocultar y mostrar reloj de espera
function ocultarReloj(){
    $('#idreloj').hide();
}
function mostrarReloj(){
    $('#idreloj').show();
}

// Buscar el idioma en la URL

function buscaIdiomaURL(){
	var lang = location.search.split('lang=')[1];
	if (lang != "en") {
        lang = "es";
    };
	localStorage.setItem("kpridioma", lang);
	GLBidiomaActual=lang;			
}

//End global variables


// Traductor
var idiomaCargado;  // Idioma seleccionado en el panel

// Función para convertir cada etiqueta tkey en el valor, según se espcifica en los archvios json de traducción
var tkey2text = function (jsonData) {	
	$("[tkey]").each (function (index) {
		var strTr = jsonData [$(this).attr ('tkey')];
	    $(this).html(strTr);
	});
};

// Función para inicializar las fechas de búsqueda.
function inicFechas() {
  GLBidiomaActual=localStorage.getItem("kpridioma");
  $("#fechaInicio").datepicker("option", { 
    monthNames: monthNames[GLBidiomaActual], 
    dayNamesMin: dayNames[GLBidiomaActual], 
    dateFormat: dateFormats[GLBidiomaActual], 
    minDate: GLBdateMinConsultable, 
    maxDate: GLBdateMaxConsultable, 
    defaultDate: GLBdateMinConsultable 
  });
  $('#fechaInicio').datepicker("setDate", GLBfechaMinLang[GLBidiomaActual]);
  $("#fechaFin").datepicker("option", { 
    monthNames: monthNames[GLBidiomaActual], 
    dayNamesMin: dayNames[GLBidiomaActual], 
    dateFormat: dateFormats[GLBidiomaActual], 
    minDate: GLBdateMinConsultable, 
    maxDate: GLBdateMaxConsultable, 
    defaultDate: GLBdateMaxConsultable,
  });
  $('#fechaFin').datepicker("setDate", GLBfechaMaxLang[GLBidiomaActual]);
  $("#fechaInicioMin").datepicker("option", { 
    monthNames: monthNames[GLBidiomaActual], 
    dayNamesMin: dayNames[GLBidiomaActual], 
    dateFormat: dateFormats[GLBidiomaActual],
    minDate: GLBdateMinConsultable, 
    maxDate: GLBdateMaxConsultable, 
    defaultDate: GLBdateMinConsultable 
  });
  $('#fechaInicioMin').datepicker("setDate", GLBfechaMinLang[GLBidiomaActual]);
  $('#fechaInicioMin').val(GLBfechaMinLang[GLBidiomaActual]);
  $("#fechaFinMax").datepicker("option", { 
    monthNames: monthNames[GLBidiomaActual], 
    dayNamesMin: dayNames[GLBidiomaActual], 
    dateFormat: dateFormats[GLBidiomaActual],
    minDate: GLBdateMinConsultable, 
    maxDate: GLBdateMaxConsultable, 
    defaultDate: GLBdateMaxConsultable,
  });
  $('#fechaFinMax').datepicker("setDate", GLBfechaMaxLang[GLBidiomaActual]);
  $('#fechaFinMax').val(GLBfechaMaxLang[GLBidiomaActual]);
}

// Función para convertir todos los campos (tkey) a texto en el idioma que corresponda
function traducirCampos() {
    // GLBidiomaActual=localStorage.getItem("kpridioma");
    $("#enlaceGuiadeuso").attr("href", GLBug[GLBidiomaActual]);
	  $("#sistemaVigAmb").attr("href", "/"+ GLBidiomaActual + "/sistema-de-vigilancia-ambiental-en-espana");

    if (GLBidiomaActual == 'es') {
      document.getElementById("banderaen").style.opacity = "0.3";
      document.getElementById("banderaes").style.opacity = "1";		
		  document.title = 'KPRGISWEB: Resultados de la vigilancia radiologica ambiental en España';
    }
    else {
      document.getElementById("banderaen").style.opacity = "1";
      document.getElementById("banderaes").style.opacity = "0.3";
		  document.title = 'KPRGISWEB: Results of radiological environmental surveillance in Spain';
    }

    
    if (idiomaCargado!=GLBidiomaActual) {

      $("#fechaInicio").datepicker("option", { monthNames: monthNames[GLBidiomaActual], dayNamesMin: dayNames[GLBidiomaActual], dateFormat: dateFormats[GLBidiomaActual] });
      $("#fechaFin").datepicker("option", { monthNames: monthNames[GLBidiomaActual], dayNamesMin: dayNames[GLBidiomaActual], dateFormat: dateFormats[GLBidiomaActual] });
      $("#fechaInicioMin").datepicker("option", { monthNames: monthNames[GLBidiomaActual], dayNamesMin: dayNames[GLBidiomaActual], dateFormat: dateFormats[GLBidiomaActual] });
      $("#fechaFinMax").datepicker("option", { monthNames: monthNames[GLBidiomaActual], dayNamesMin: dayNames[GLBidiomaActual], dateFormat: dateFormats[GLBidiomaActual] });
      $('#fechaInicioMin').datepicker("setDate", GLBdateMinConsultable);
      $('#fechaInicioMin').val(GLBfechaMinLang[GLBidiomaActual]);
      $('#fechaFinMax').datepicker("setDate", GLBdateMaxConsultable);
      $('#fechaFinMax').val(GLBfechaMaxLang[GLBidiomaActual]);


      $("#comboAnalisis").load(GLBanalisisHTML[GLBidiomaActual], function() {// Traducir sólo cuando ha terminado de cargar el combo de análisis
				$.getJSON(GLBtradURL[GLBidiomaActual], tkey2text);
			});
			idiomaCargado = GLBidiomaActual;
    };
	
};

function translateFrase(laFrase) {
	var frase;
	if (GLBtraduccionES ==null || GLBtraduccionEN == null || laFrase == null){
		if (laFrase == null){
			return "";	//entoavia no ha cargado
		}		
		return laFrase;	//entoavia no ha cargado
	}
	frase=laFrase.toUpperCase().replace('-',' ');
    if (GLBidiomaActual == 'en') {
		for (var trad in GLBtraduccionES) {	
			if (GLBtraduccionES[trad].toUpperCase().replace('-',' ')==frase) {
				return(GLBtraduccionEN[trad]);//dejo de buscar y devuelvo la encontrada
			}
		}
  }
  return laFrase; //si no la encuentra, devuelve el original
  };

function traducirDesdeCodigo(codigo){
	// var frase;
	if (GLBtraduccionES == null || GLBtraduccionEN == null || codigo == null){
		if (codigo == null){
			return "";	//entoavia no ha cargado
		}		
		return codigo;	//entoavia no ha cargado
	}
    if (GLBidiomaActual == 'en') {
		for (var trad in GLBtraduccionEN) {	
			if (trad==codigo) {
				return(GLBtraduccionEN[trad]);//dejo de buscar y devuelvo la encontrada
			}
		}
    }
	else {
		for (var trad in GLBtraduccionES) {	
			if (trad==codigo) {
				return(GLBtraduccionES[trad]);//dejo de buscar y devuelvo la encontrada
			}
		}
	}
	return codigo; //si no la encuentra, devuelve el original
};

// URLs for datatables languages
const dtLangURLs = {
	'en': 'https://cdn.datatables.net/plug-ins/2.3.4/i18n/en-GB.json',
	'es': 'https://cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/Spanish.json'
};

$.ajax({	//ASINCRONOOOOO!!!!
	type:'GET',
	// url:'./traducciones3/es.json',
	url: GLBtradURLes,
	dataType:'JSON',
	data:{ 
	},
	success:function(data){
		GLBtraduccionES = data;
	},
	error:function(XMLHttpRequest,textStatus,errorThrown){
		console.log("error es.json");
	}
});

$.ajax({	//ASINCRONOOOOO!!!!
	type:'GET',
	// url:'./traducciones3/en.json',
	url: GLBtradURLen,
	dataType:'JSON',
	data:{ 
	},
	success:function(data){
		GLBtraduccionEN = data;
	},
	error:function(XMLHttpRequest,textStatus,errorThrown){
		console.log("error en.json");
	}
});

// End traductor

// const estacionesURL = "http://localhost:4000/mapa/estaciones"
const extent = [-2500000.0, 2900000.0, 1400000.0, 5800000.0];   // Área representada en el mapa
const centroPeninsula = [-450000.0, 4840000.0];   // Centro aproximado de la península en coordenadas EPSG:3857
const initPeninsulaZoom = 6.8;                    // Zoom inicial a la península
const centroCanarias = [-1756204.01,3300549.35];  // Centro aproximado de Canarias en coordenadas EPSG:3857
const initCanariasZoom = 8.0;                     // // Zoom inicial a Canarias
const centroBaleares = [292964.92,4791240.21];  // Centro aproximado de Canarias en coordenadas EPSG:3857
const initBalearesZoom = 9.0;                     // // Zoom inicial a Canarias

var tablaMuestrasEstacion;    // Tabla datatales con las muestras de una estación
var tablaAnalisis;    // Tabla datatales con el análisis de un isótopo

// Hashmap con los posibles iconos dependiendo del tipo de estación
const iconos = {
  "edificio": {
    iconsrc: './img/edificio.png',
    size: {
      width: 25,
      height: 32
    },
    name: 'Edificio'
  },
  "central": {
    iconsrc: centralIcon,
    size: {
      width: 50,
      height: 30
    },
    name: 'Central Nuclear'    
  },
  "REM": {
    iconsrc: './img/bolaverde.gif',
    iconsrc: bolaverdeIcon,
    size: {
      width: 12,
      height: 12
    },
    name: 'Programa nacional'    
  }, 
  "PVRA": {
    iconsrc: bolaazulIcon,
    size: {
      width: 12,
      height: 12
    },
    name: 'Vigilancia a instalaciones'    
  }, 
  "todo": {
    iconsrc: './img/atomo.png',
    size: {
      width: 30,
      height: 32
    },
    name: 'Todo'    
  },
  "fabrica": {
    iconsrc: fabricaIcon,
    size: {
      width: 48,
      height: 44
    },
    name: 'Fábrica de combustible'    
  },
  "almacen": {
    iconsrc: almacenIcon,
    size: {
      width: 30,
      height: 45
    },
    name: 'Almacenamiento residuos'    
  },
  "mina": {
    iconsrc: minaIcon,
    size: {
      width: 39,
      height: 38
    },
    name: 'Fábrica concent. uranio'    
  },
  "centro_invest": {
    iconsrc: centroinvestigacionIcon,
    size: {
      width: 57,
      height: 33
    },
    name: 'Centro investigación'    
  },
  "contaminadas": {
    iconsrc: contaminadasIcon,
    size: {
      width: 50,
      height: 50
    },
    name: 'Vigilancias especiales'    
  }, 
};

// El índice del array coincide con el tipo de estación en el campo ti del JSON
const iconArray = ['edificio', 'central', 'REM', 'PVRA', 'todo', 'fabrica', 'almacen', 'mina', 'centro_invest', 'contaminadas'];
var estLayers = {};

// Control de mapa para añdir una barra de escala
const mapcontrol = new ScaleLine({
  units: 'metric',
  bar: true,
  steps: 4,
  text: true,
  minWidth: 140,
});

const map = new Map({
  controls: defaultControls().extend([mapcontrol]),
  target: 'map',
  layers: [
  ],
  view: new View({
    extent: extent,
    center: centroPeninsula,
    zoom: initPeninsulaZoom,
    minZoom: 5,
    maxZoom: 20
  })
});

const OSMlayer = new TileLayer({
  source: new OSM(),
  visible: true,
});

const OTMlayer = new Tile({
  source: new OSM({
    url: 'https://{a-c}.tile.opentopomap.org/{z}/{x}/{y}.png'
  }),
  visible: false,
});

const PNOAlayer = new TileLayer({
  source: new TileWMS({
    url: 'https://www.ign.es/wms-inspire/pnoa-ma',
    crossOrigin: 'anonymous',
    attributions: 
      '© <a href="https://www.ign.es/web/ign/portal"' +
      'target="_blank">Sistema Cartográfico Nacional</a>',
    params: {
      'LAYERS': 'OI.OrthoimageCoverage',
      'FORMAT': 'image/jpeg',
    },
    serverType: 'mapserver',
  }),
  visible: false,
});

map.addLayer(OSMlayer);
map.addLayer(OTMlayer);
map.addLayer(PNOAlayer);

// Definir la proyección ETRS89, que no viene incluida por defecto en OpenLayers
proj4.defs("EPSG:4258", "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs"); 
register(proj4);

// Definir la proyección en la que vienen las coordenadas de la capa de estaciones
const estProjection = new Projection({
  code: GLBvlayerSources.estResto.crs.properties.name,
  units: GLBvlayerSources.estResto.crs.properties.units
});

const sourceFormats = {};
sourceFormats['Resto'] = new GeoJSON({
  dataProjection: estProjection, 
  featureProjection: map.getView().getProjection()
});
sourceFormats['REM'] = new GeoJSON({
  dataProjection: estProjection, 
  featureProjection: map.getView().getProjection()
});
sourceFormats['PVRA'] = new GeoJSON({
  dataProjection: estProjection, 
  featureProjection: map.getView().getProjection()
});

// Función para el info callback de la tabla de análisis
const TablaMuestrasInfoCB = function(settings, start, end, max, total, pre) {
  if (GLBidiomaActual == 'es') {
    if (total == 0) {
      return 'No hay muestras disponibles';
    }
    else if (total == 1) {
      return '1 muestra';
    }
    else {
      return `${total} muestras`;
    }
  }
  else if (GLBidiomaActual == 'en') {
    if (total == 0) {
      return 'No samples available';
    }
    else if (total == 1) {
      return '1 sample';
    }
    else {
      return `${total} samples`;
    }
  }
};

// Función para el info callback de la tabla de análisis
const TablaAnalisisInfoCB = function(settings, start, end, max, total, pre) {
  if (GLBidiomaActual == 'es') {
    if (total == 0) {
      return 'No hay medidas disponibles';
    }
    else if (total == 1) {
      return '1 medida';
    }
    else {
      return `${total} medidas`;
    }
  }
  else if (GLBidiomaActual == 'en') {
    if (total == 0) {
      return 'No measures available';
    }
    else if (total == 1) {
      return '1 measure';
    }
    else {
      return `${total} measures`;
    }
  }
};

// Función para transformar datos de estaciones en GeoJSON
const data2geoJSON = function (jsonData) {

  estLayers['Resto'].getSource().clear();
  estLayers['REM'].getSource().clear();
  estLayers['PVRA'].getSource().clear();
  GLBvlayerSources['estResto'].features = [];
  GLBvlayerSources['estREM'].features = [];
  GLBvlayerSources['estPVRA'].features = [];
  for (var idx=0; idx<jsonData.length; idx++) {  // Bucle sobre los elementos del JSON (estaciones)
    const feature = {
      'type': 'Feature',
      'id': idx,
      'geometry': {
        'type': 'Point',
        'coordinates': [parseFloat(jsonData[idx].y), parseFloat(jsonData[idx].x)]
      },
      'properties': {
        'id_est': jsonData[idx].ie,
        'tipo': parseInt(jsonData[idx].ti),  // Tipo de instalación
        'id_zona': jsonData[idx].izv,   // Identificador de la zona de vigilancia
        'nombre_est':   jsonData[idx].ne,   // Nombre de la estación
        'nombre_zona':   jsonData[idx].zv   // Nombre de la zona de vigilancia
      }
    };
    if (parseInt(jsonData[idx].ti) == 2) {  // Estación de la red nacional
      GLBvlayerSources['estREM'].features.push(feature);
    }
    else if (parseInt(jsonData[idx].ti) == 3) {  // Estación de la red de vigilancia de las instalaciones
      GLBvlayerSources['estPVRA'].features.push(feature);
    }
    else {  // Resto de instalaciones
      GLBvlayerSources['estResto'].features.push(feature);
    }
  };

  // Añadir objetos vectoriales a cada una de las 3 capas.
  const featuresResto = sourceFormats['Resto'].readFeatures(GLBvlayerSources.estResto);
  const featuresREM = sourceFormats['REM'].readFeatures(GLBvlayerSources.estREM);
  const featuresPVRA = sourceFormats['PVRA'].readFeatures(GLBvlayerSources.estPVRA);

  // Actualizar features en la capa vectorial
  estLayers['Resto'].getSource().addFeatures(featuresResto);
  estLayers['REM'].getSource().addFeatures(featuresREM);
  estLayers['PVRA'].getSource().addFeatures(featuresPVRA);
  
  setNumEstaciones();
  ocultarReloj();
};

// Función de búsqueda de estaciones
const BotonBuscarClick = function() {
	$("#contador").html("...");
	mostrarReloj();
  
  var fechatmp, offset, fechaoffset;
	fechatmp = $('#fechaInicio').datepicker("getDate")
  offset = fechatmp.getTimezoneOffset();
  fechaoffset = new Date(fechatmp.getTime() - (offset*60*1000));
  GLBfechaInicio = fechaoffset.toISOString().split('T')[0];

	fechatmp = $('#fechaFin').datepicker("getDate")
  offset = fechatmp.getTimezoneOffset();
  fechaoffset = new Date(fechatmp.getTime() - (offset*60*1000));
  GLBfechaFin = fechaoffset.toISOString().split('T')[0];

	
	GLBMuestra=$("#optiontipoMuestra").val();
	GLBAnalisis=$("#comboAnalisis").val();
	GLBIdZonaVigilancia=$("#optionZonaVigilancia").val();
	if (GLBAnalisis==null) {
		GLBAnalisis=0;
		}
	GLBPrograma=$('input:radio[name=radioValueProgramaVigilancia]:checked').val();
	
	var cacheEstaciones=0;
	if (GLBfechaInicio=="2006-01-01" && GLBfechaFin == "2050-12-31" && GLBMuestra == 0 && GLBAnalisis == 0 && $("#checkboxCache").prop("checked") == true)
		{
			cacheEstaciones=1;
		}
	cacheEstaciones=0;//quito cache
	
	var destino;
	if (conJSON==1 || cacheEstaciones==1)	{destino="./json/estaciones696servicio.json";}
	else if (conJSON==2)	{destino="http://193.144.25.112:8080/kprgisweb2/estaciones/"}
	else if (conJSON==3)	{destino="http://localhost:7001/kprgisweb2/estaciones/"}
	else 			{destino="https://www.csn.es/kprgisweb2/estaciones/"}
	
	destino = destino + "?id_zona=" + GLBIdZonaVigilancia + 
			"&fecha_inicio=" + GLBfechaInicio + 
			"&fecha_fin=" + GLBfechaFin + 
			"&id_mues=" + GLBMuestra + 
			"&id_an=" + GLBAnalisis + 
			"&programa=" + GLBPrograma + "";	
	if (debugURL==1) {console.log("estaciones: " + destino);}
	
  $.getJSON(destino, data2geoJSON);
};


const estRestoStyleFunction = function (feature) {
    const style = new Style({
    image: new Icon({
      // anchor: [0.5, 1.0],
      src: iconos[iconArray[feature.get('tipo')]].iconsrc,
      width: iconos[iconArray[feature.get('tipo')]].size.width,
      height: iconos[iconArray[feature.get('tipo')]].size.height,
    }),
    zIndex: 10,
  })
  return style;

};

// Contenedor para el tooltip que se muestra haciendo hovering sobre las estaciones
const infoElement = document.getElementById('info');
infoElement.style.pointerEvents = 'none';

// Elemento con el tooltip
const tooltip = new bootstrap.Tooltip(infoElement, {
  animation: false,
  customClass: 'pe-none',
  offset: [0, 5],
  title: '-',
  trigger: 'manual',
});

// Estación sobre la que está situado el ratón
var currentFeature;

// Función para encontrar la estación sobre la que está el ratón y definir el contenido del tooltip
const displayFeatureInfo = function (pixel, target) {
  const feature = target.closest('.ol-control')
    ? undefined
    : map.forEachFeatureAtPixel(pixel, function (feature) {
        return feature;
      },);
  if (feature) {
    // const hit = map.hasFeatureAtPixel(pixel);
    // map.getTargetElement().style.cursor = hit ? 'pointer' : '';
    target.style.cursor = 'pointer';
    infoElement.style.left = pixel[0] + 'px';
    infoElement.style.top = pixel[1] + 'px';
    if (feature !== currentFeature) {
      var tooltip_text = feature.get('nombre_zona');  // Añadir nombre de la zona al texto del tooltip
      if (feature.get('nombre_est')) { // Añadir nombre de la estación si no es nulo
        tooltip_text = tooltip_text + "\n" + feature.get('nombre_est');
      }
      tooltip.setContent({'.tooltip-inner': tooltip_text});  // Poner el texto en el tooltip
    }
    if (currentFeature) {
      tooltip.update();
    } else {
      tooltip.show();
    }
  } else {
    target.style.cursor = '';
    tooltip.hide();
  }
  currentFeature = feature;
};

// Invocar la función que encuentra la estación cuando el ratón se sitúa encima
map.on('pointermove', function (evt) {
  if (evt.dragging) {
    tooltip.hide();
    currentFeature = undefined;
    return;
  }
  displayFeatureInfo(evt.pixel, evt.originalEvent.target);
});

// Función para mostrar la ventana que contiene las muestras de la estación elegida
map.on('singleclick', function (evt) {
  var link;
  const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
    return feature;
  }, {hitTolerance: 3});  // Ampliado hitTolerance para que sea más fácil hacer click en pantallas táctiles
  if (!feature) {
    return;
  }
  else {
    GLBIdZonaVigilancia = feature.get('id_zona');
    GLBIDestacion = feature.get('id_est');
    GLBZonaVigilancia = feature.get('nombre_zona');
    GLBNombreEstacion = feature.get('nombre_est');
    if (GLBIDestacion) {
      mostrarVentanaMuestrasEstacion();
    }
    else {
      if (GLBIdZonaVigilancia != 'BFH') {  // La balsa de fosfoyesos de Huelva no tiene enlace asociado
        // link = GLBhost;             // Poner en host en la URL
        link = '';
        if (GLBIdZonaVigilancia != 'PAL') {   // Palomares sólo tiene un documento. No tiene idioma
          link = link + '/' + GLBidiomaActual;    // Añadir el idioma a la URL.
        }
        link = link + GLBinstURLs[GLBIdZonaVigilancia];
        window.open(link, '_blank');  // Abrir enlace en nueva pestaña.
      }    
    }
  }

  
});


// Añadir capas vectoriales al mapa
const AddLayers2Map = function() {

  // Definir capas vectoriales usando las features correspondientes.
  estLayers['Resto'] = new VectorLayer({
    source: new VectorSource({
      // features: featuresResto
    }),
    style: estRestoStyleFunction
  });  
  estLayers['REM'] = new VectorLayer({
    source: new VectorSource({
      // features: featuresREM
    }),
    style: new Style({
      image: new Icon({
        src: iconos.REM.iconsrc,
        width: iconos.REM.size.width,
        height: iconos.REM.size.height,
      })
    })
  });
  estLayers['PVRA'] = new VectorLayer({
    source: new VectorSource({
      // features: featuresPVRA
    }),
    style: new Style({
      image: new Icon({
        src: iconos.PVRA.iconsrc,
        width: iconos.PVRA.size.width,
        height: iconos.PVRA.size.height,
      })
    })
  });

  // Añadir capas vectoriales al mapa.
  map.addLayer(estLayers['Resto']);
  map.addLayer(estLayers['REM']);
  map.addLayer(estLayers['PVRA']);

};

const traducirPagina = function(idioma) {
	localStorage.setItem("kpridioma", idioma);
	GLBidiomaActual = idioma;
  traducirCampos();
};

const setNumEstaciones = function() {
  var numEstaciones;
  if ($('#BTNradioTodas').is(':checked')) {
    numEstaciones = 
      GLBvlayerSources['estREM']['features'].length +
      GLBvlayerSources['estPVRA']['features'].length;
  }
  else if ($('#BTNradioVerde').is(':checked')) {
    numEstaciones =  
      GLBvlayerSources['estREM']['features'].length;
  }
  else if ($('#BTNradioAzul').is(':checked')) {
    numEstaciones = 
      GLBvlayerSources['estPVRA']['features'].length;
  }
  $("#contador").html(numEstaciones);
};


// Función para convertir los datos de muestras de una estación 
// a la tabla correspondiente
const data2Muestras = function(data) {
  if (tablaMuestrasEstacion) {
    tablaMuestrasEstacion.clear();
  }
  else {
    tablaMuestrasEstacion = $('#tablaMuestrasEstacion').DataTable({
      "infoCallback": TablaMuestrasInfoCB,
      "iDisplayLength": 200,
      "lengthChange": false,
      "info": true,
      "paging": false,
      "scrollCollapse": true,
      "scrollY": '650px',
      // "scrollY": '620px',
      "ordering": false,
      // "order": [[0, "asc"]],
      "searching": false,
      "columns": [
        {  },
        {  },
        {  },
      ],
    });
  }
  GLBmuestrasEstacion = data;
  GLBTipoVigilancia = data[0].mo;
  $('#muestraFinicio').text(': ' + GLBfechaInicio);
  $('#muestraFfin').text(': ' + GLBfechaFin);
  // $('#muestraZonaVig').text(': ' + currentFeature.get('nombre_zona').toUpperCase());
  $('#muestraZonaVig').text(': ' + GLBZonaVigilancia.toUpperCase());
  // $('#muestraEstacion').text(': ' + currentFeature.get('nombre_est').toUpperCase());
  $('#muestraEstacion').text(': ' + GLBNombreEstacion.toUpperCase());
  $('#muestraTipoVig').text(': ' + translateFrase(data[0].mo).toUpperCase());

  var row = tablaMuestrasEstacion.row;

  for (var idx=0 ; idx<data.length; idx++) {
    var datarow = data[idx];
    var fila = [
      translateFrase(datarow.mu).toUpperCase(),
      translateFrase(datarow.an).toUpperCase() + " / " + '<a href="javascript:" class="isotopo" idx="' + idx + '">' + 
        translateFrase(datarow.isot).toUpperCase() + '</a>',
      translateFrase(datarow.num).toUpperCase()
    ];
    row.add(fila).draw(true);
  };
  ocultarReloj();
  if ($("#divMuestrasEstacion").is(":hidden")) {
    $("#divMuestrasEstacion").fadeIn("slow");
    $('#divBuscador').hide();
  }
  // $('#tablaMuestrasEstacion').DataTable().columns.adjust().draw();
  tablaMuestrasEstacion.columns.adjust().draw();
  
};

// Construir y mostrar la ventana de muestras de una estación
const mostrarVentanaMuestrasEstacion = function() {
  mostrarReloj();
  tooltip.hide();	
  var destino;
	if (conJSON==1)	{destino="./json/estacion.json";}
	else if (conJSON==2)	{destino="http://193.144.25.112:8080/kprgisweb2/estacion/"}
	else 			{destino="https://www.csn.es/kprgisweb2/estacion/"}
	
	destino = destino + "?id_zona=" + GLBIdZonaVigilancia + 
			"&id_est=" + GLBIDestacion + 
			"&fecha_inicio=" + GLBfechaInicio + 
			"&fecha_fin=" + GLBfechaFin + 
			"&id_mues=" + GLBMuestra +
			"&id_an=" + GLBAnalisis + 
			"&programa=" + GLBPrograma + "";	

  $.getJSON(destino, data2Muestras);
  
};

// Nodo del canvas para alojar la gráfica chart.js
const ctx = document.getElementById('analisisChart').getContext('2d');
// Constante para alojar el objeto chart.js
var analisisChart;

const data2Analisis = function(data) {
  ocultarReloj();
  var datos = [];
  const units = data[0].un;
  data.forEach( fila => {
    var year;
    var month;
    var day;
    var act;
    var uncert;
    [day, month, year] = fila.ffin.split("/");
    const datestr = year + '-' + month + '-' + day;
    if (fila.act) {
      act = parseFloat(fila.act.replace(",","."));
    }
    else {
      act = 0;
    };
    if (fila.in) {
      uncert = parseFloat(fila.in.replace(",","."));
    }
    else {
      uncert = 0;
    };
    datos.push({
      'act': act,
      'uncert': uncert,
      'units':  fila.un,
      'lid': parseFloat(fila.lid.replace(",",".")),
      'ffin': new Date(datestr)
    })
  });
  // Filtrar datos de Activity donde activity > LID
  const activityData = datos
    .filter(d => (d.act >= d.lid) || !(d.lid))
    .map(d => ({
      x: d.ffin,
      y: d.act,
      uncert: d.uncert
  }));

   // Datos de LID (todos los puntos)
   const lidData = datos.map(d => ({
     x: d.ffin,
     y: d.lid
   }));

  // Configuración del gráfico
  
  analisisChart = new Chart(ctx, {
    type: 'scatter',
    data: {
      datasets: [
        {
          label: traducirDesdeCodigo('xx030'),
          data: activityData,
          backgroundColor: '#47C04E',
          borderColor: '#143D16',
          borderWidth: 2,
          pointRadius: 6,
          pointHoverRadius: 8
        },
        {
          label: traducirDesdeCodigo('xx032'),
          data: lidData,
          backgroundColor: 'rgba(255, 255, 255, 0.0)',
          borderColor: '#000000',
          borderWidth: 2,
          pointRadius: 6,
          pointHoverRadius: 8
        }
      ]
    },
    options: {
      maintainAspectRatio: false,
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        tooltip: {
          callbacks: {
            title: function(context) {
              const dataPoint = context[0];
              const fecha = new Date(dataPoint.parsed.x);
              return fecha.toLocaleDateString(GLBidiomaActual + '-' + GLBidiomaActual.toUpperCase());
            },
            label: function(context) {
              const datasetLabel = context.dataset.label;
              if (datasetLabel === traducirDesdeCodigo('xx030')) {
                const rawData = context.raw;
                return `${traducirDesdeCodigo('xx030')}: ${rawData.y.toExponential()} ± ${rawData.uncert.toExponential()} ${units}`;
              } else {
                return `${traducirDesdeCodigo('xx032')}: ${context.parsed.y.toExponential()} ${units}`;
              }
            }
          }
        },
        legend: {
          display: true,
          position: 'top'
        },
        // zoom: {
        //   pan: {
        //     enabled: true
        //   },
        //   zoom: {
        //     wheel: {
        //       enabled: true
        //     }
        //   }
        // }
      },
      scales: {
        x: {
          type: 'time',
          time: {
            unit: 'year',
            displayFormats: {
              year: 'yyyy'
            }
          },
          title: {
            display: true,
            // text: 'Fecha',
            font: {
              size: 14,
              weight: 'bold'
            }
          },
          grid: {
            display: true,
            color: 'rgba(0, 0, 0, 0.1)'
          }
        },
        y: {
          type: 'logarithmic',
          title: {
            display: true,
            text: `${units}`,
            font: {
              size: 14,
              weight: 'bold'
            }
          },
          grid: {
            display: true,
            color: 'rgba(0, 0, 0, 0.1)'
          }
        }
      }
    }
  });

  GLBdownloadTitle = `${GLBIdZonaVigilancia}_${GLBIDestacion}_${GLBmuestraId}_${GLBmuestraIdIsot}`; 

  if (tablaAnalisis) {
    tablaAnalisis.clear();
  }
  else {
    tablaAnalisis = $('#tablaAnalisisIsotopo').DataTable({
      "infoCallback": TablaAnalisisInfoCB,
      "layout": {
        "topEnd": {
          "buttons": [
            {
              extend: 'csvHtml5',
              // title: 'Data export'
            },
            {
              extend: 'excelHtml5',
              title: `${GLBdownloadTitle}`
            }
          ]
        },
        "topStart": null
      },
      "iDisplayLength": 200,
      "lengthChange": false,
      "info": true,
      "paging": false,
      "scrollCollapse": true,
      "scrollY": '700px',
      "ordering": false,
      // "order": [[0, "asc"]],
      "searching": false,
      "columns": [
        {  },
        {  },
        {  },
        {  },
        {  },
        {  },
      ],
    });

  }

  var row = tablaAnalisis.row;

  for (var idx=0 ; idx<data.length; idx++) {
    var day, month, year;
    var datarow = data[idx];
    var activity = data[idx].act;
    var uncertainty = data[idx].in;
    var lid = data[idx].lid;
    var fini = data[idx].fini;
    var ffin = data[idx].ffin;
    if (GLBidiomaActual == 'en') {
      activity = activity.replace(",", ".");
      uncertainty = uncertainty.replace(",", ".");
      lid = lid.replace(",", ".");
      [day, month, year] = fini.split('/');
      fini = `${month}/${day}/${year}`;
      [day, month, year] = ffin.split('/');
      ffin = `${month}/${day}/${year}`;
    }

    var fila = [
      activity,
      uncertainty,
      lid,
      data[idx].un,      
      fini,
      ffin
    ];
    row.add(fila).draw(true);
  };

  $('#divAnalisisIsotopo').fadeIn("slow");
  $('#tablaAnalisisIsotopo').DataTable().columns.adjust().draw();
  $('#divMuestrasEstacion').hide();
  $('#divBuscador').hide();
  tooltip.hide();
};

const mostrarAnalisisIsotopo = function(idx) {
  tooltip.hide();
  mostrarReloj();
  GLBmuestraId = GLBmuestrasEstacion[idx].imu;
  GLBmuestraIdIsot = GLBmuestrasEstacion[idx].iisot;
  $('#analisisZonaVig').text(': ' + GLBZonaVigilancia.toUpperCase());
  $('#analisisEstacion').text(': ' + GLBNombreEstacion.toUpperCase());
  $('#analisisTipoVig').text(': ' + translateFrase(GLBTipoVigilancia).toUpperCase());
  $('#analisisMuestra').text(': ' + translateFrase(GLBmuestrasEstacion[idx].mu).toUpperCase());
  $('#analisisIsotopo').text(': ' + translateFrase(GLBmuestrasEstacion[idx].isot).toUpperCase());
  
  var destino;
  if (conJSON==1)     {destino="./json/analisis-isotopo.json";}
  else if (conJSON==2){destino="http://193.144.25.112:8080/kprgisweb2/analisis/";}
  else                {destino="https://www.csn.es/kprgisweb2/analisis/";}
   
  destino = destino + "?id_zona=" + GLBIdZonaVigilancia + 
         "&id_est=" + GLBIDestacion + 
         "&fecha_inicio=" + GLBfechaInicio + 
         "&fecha_fin=" + GLBfechaFin + 
         "&id_mot=" + GLBmuestrasEstacion[idx].imo + 
         "&id_mues=" + GLBmuestrasEstacion[idx].imu + 
         "&id_an=" + GLBmuestrasEstacion[idx].ian + 
         "&isotopo=" + GLBmuestrasEstacion[idx].iisot + "";

  $.getJSON(destino, data2Analisis);
};

// Nodo del canvas para alojar la gráfica chart.js
const chartContext = document.getElementById("estacionChart");
// Constante para alojar el objeto chart.js
var estacionChart;

// Acciones cuando se haya terminado de cargar la página.
$(document).ready(function () {
  // Cierre o apertura del panel lateral
  $('#botonmenuCierra').click(function(){
	  $('#divBuscador').toggle("slide");
	  $("#botonmenuCierra").hide();
	  $("#botonmenuAbre").show();
    GLBbuscadorShown = false;
  });
  $('#botonmenuAbre').click(function(){
	  $('#divBuscador').toggle("slide");
	  $("#botonmenuAbre").hide();
	  $("#botonmenuCierra").show();
    GLBbuscadorShown = true;
  });
  $('#banderaes').click(function(){
    traducirPagina('es');
  });
  $('#banderaen').click(function(){
    traducirPagina('en');
  });
  $('#BTNradioTodas').change(function(){
    estLayers['REM'].setVisible(true);
    estLayers['PVRA'].setVisible(true);
    setNumEstaciones();
    $("[zonavig2]").each (function (index) {
	    $(this).removeClass("oculto");
	  });
	  $("[zonavig3]").each (function (index) {
	    $(this).removeClass("oculto");
	  });	
  });
  $('#BTNradioVerde').change(function(){
    estLayers['REM'].setVisible(true);
    estLayers['PVRA'].setVisible(false);
    setNumEstaciones();
    $("[zonavig3]").each (function (index)  {
	    $(this).addClass("oculto");
	  });
	  $("[zonavig2]").each (function (index)  {
	    $(this).removeClass("oculto");
	  });
  });
  $('#BTNradioAzul').change(function(){
    estLayers['REM'].setVisible(false);
    estLayers['PVRA'].setVisible(true);
    setNumEstaciones();
	  $("[zonavig2]").each (function (index)  {
	    $(this).addClass("oculto");
	  });
	  $("[zonavig3]").each (function (index) {
	    $(this).removeClass("oculto");
	  });	
  });
  $('#peninsula').click(function(){
    map.getView().setCenter(centroPeninsula);
    map.getView().setZoom(initPeninsulaZoom);
  });
  $('#canarias').click(function(){
    map.getView().setCenter(centroCanarias);
    map.getView().setZoom(initCanariasZoom);
  });
  $('#baleares').click(function(){
    map.getView().setCenter(centroBaleares);
    map.getView().setZoom(initBalearesZoom);
  });
  $('#botonBuscar').click(function(){
    BotonBuscarClick();
  });
  $('#buttonCierreMuestras').click(function() {
    tablaMuestrasEstacion.clear();
    $("#divMuestrasEstacion").fadeOut("slow", function() {
		});
    if (GLBbuscadorShown) {
      $('#divBuscador').show();
    }
  });
  $('#buttonCierreAnalisis').click(function() {
    // $('#divBuscador').show();
    $('#divMuestrasEstacion').show();
    $('#divBuscador').hide();
    $("#divAnalisisIsotopo").fadeOut("slow", function() {
		});
    analisisChart.clear();
    analisisChart.destroy();
  });
  $(document).on("click", ".isotopo", function(elem) {
    mostrarAnalisisIsotopo(parseInt(elem.target.getAttribute("idx")));
    
  });
  $('#chart2pngButton').click(function() {
    $('#buttonCierreAnalisis').hide();
    $('#chart2pngButton').hide();
    const divAnIsot = $('#divCabeceraGrafica')[0];
    html2canvas(divAnIsot).then((canvas) => {
      const filename = `${GLBdownloadTitle}.png`; 
      const link = document.createElement("a");
      link.download = filename;
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
    $('#buttonCierreAnalisis').show();
    $('#chart2pngButton').show();
  });

  // Ver mapa OSM
  $('#OSM').click(function() {
    OSMlayer.setVisible(true);
    OTMlayer.setVisible(false);
    PNOAlayer.setVisible(false);
    $('#OSM').addClass('mapButtonSelected');
    $('#OTM').removeClass('mapButtonSelected');
    $('#PNOA').removeClass('mapButtonSelected');
  });

  // Ver mapa OTM
  $('#OTM').click(function() {
    OSMlayer.setVisible(false);
    OTMlayer.setVisible(true);
    PNOAlayer.setVisible(false);
    $('#OSM').removeClass('mapButtonSelected');
    $('#OTM').addClass('mapButtonSelected');
    $('#PNOA').removeClass('mapButtonSelected');
  });

  // Ver mapa PNOA
  $('#PNOA').click(function() {
    OSMlayer.setVisible(false);
    OTMlayer.setVisible(false);
    PNOAlayer.setVisible(true);
    $('#OSM').removeClass('mapButtonSelected');
    $('#OTM').removeClass('mapButtonSelected');
    $('#PNOA').addClass('mapButtonSelected');
  });



// Actuaciones iniciales
  mostrarReloj();
  buscaIdiomaURL();
  inicFechas();
  traducirCampos();
  AddLayers2Map();
  BotonBuscarClick();
});